import script from "./GmxRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxRadio.vue?vue&type=script&setup=true&lang=js"

import "./GmxRadio.vue?vue&type=style&index=0&id=23657b2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23657b2a"]])

export default __exports__